import styled from "styled-components";

export const CompanyBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px;
  border: 1px solid #949494;
`;

export const CommitteCompanyTitle = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
`;

export const CommitteCompanyName = styled.span`
  font-size: 16px;
  color: #000;
  font-family: "Roboto", sans-serif;
  font-weight: 500;
`;

export const CompanyActionButton = styled.button`
  color: #000;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: color 0.2s;

  :hover {
    color: #4f4f4f;
  }
`;
